import "./CustomEngraving.module.css";
import Header from "@/reusable_sections/Header";
import ServiceHeroCustom from "./sections/ServiceHeroCustom";
import WhatWeCustomEngrave from "./sections/WhatWeCustomEngrave";
import ProcessScoping from "./sections/ProcessScoping";
import WhatWeHandle from "./sections/WhatWeHandle";
import HowToSubmit from "./sections/HowToSubmit";
import ComplianceSupport from "./sections/ComplianceSupport";
import Faq from "./sections/Faq";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function CustomEngravingPage() {
  return <div>
      <Header />
      <ServiceHeroCustom />
      <WhatWeCustomEngrave />
      <ProcessScoping />
      <WhatWeHandle />
      <HowToSubmit />
      <ComplianceSupport />
      <Faq />
      <CallToAction />
      <Footer />
    </div>;
}